export default __webpack_public_path__ + "static/media/pic_no_record.ffc7da49.png";